import { URL_API_AUTH } from 'src/config';
import baseActions from '../baseActions';
import httpService from 'src/helpers/httpService';

const path = 'admin/partners';
export const actionType = (action) => {
  return {
    request: `${action}_${path}_request`.toUpperCase(),
    success: `${action}_${path}_success`.toUpperCase(),
    error: `${action}_${path}_error`.toUpperCase(),
  };
};

const http = httpService();
const merchant = {
  ...baseActions(URL_API_AUTH, path, actionType),
  fetchDetail: (id, params) => {
    return (dispatch) => {
      dispatch({ type: actionType('fetchDetail').request });
      return http.get(`${URL_API_AUTH}/partners/${id}`, { params }).then(
        (response) => {
          dispatch({ type: actionType('fetchDetail').success, response: response.data });
          return response.data;
        },
        (error) => {
          dispatch({ type: actionType('fetchDetail').error });
          throw error.response;
        },
      );
    };
  },
  updateData: (data) => {
    return (dispatch) => {
      dispatch({ type: actionType('update').request });
      return http.put(`${URL_API_AUTH}/${path}/${data?.id}`, data).then(
        (response) => {
          dispatch({ type: actionType('update').success });
          return response.data;
        },
        (error) => {
          dispatch({ type: actionType('update').error });
          throw error.response;
        },
      );
    };
  },
  deleteData: (id) => {
    return (dispatch) => {
      dispatch({ type: actionType('delete').request });
      return http.delete(`${URL_API_AUTH}/${path}/${id}`).then(
        (response) => {
          dispatch({ type: actionType('delete').success });
          return response.data;
        },
        (error) => {
          dispatch({ type: actionType('delete').error });
          throw error.response;
        },
      );
    };
  },
};
export default merchant;
